import { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { deepCopy } from '../../util/Utils'
import {
  getRelationship,
  deleteRelationshipFact,
  postRelationshipFact,
  putRelationshipFact,
} from '../../services/RelationshipService'
import useNotifications from '../../hooks/useNotifications'

export default () => {}

export function useRelationshipState(relationshipId, relationshipType) {
  const { t } = useTranslation()
  const { error } = useNotifications()

  const initialState = {
    relationshipData: undefined,
  }

  const reducer = (_, currentState) => deepCopy(currentState)

  const [relationshipState, setRelationshipState] = useReducer(reducer, initialState)

  const relationshipActions = {
    updateRelationshipState: () => {
      setRelationshipState(relationshipState)
    },
    fetchCurrentRelationship: () => {
      relationshipState.relationshipData = undefined
      relationshipActions.updateRelationshipState()
      if (relationshipId) {
        getRelationship(relationshipType, relationshipId)
          .then((results) => {
            relationshipState.relationshipData = results.data
            relationshipActions.updateRelationshipState()
          })
          .catch((err) => {
            error(
              t('queues.errors.gettingCurrentRelationship', {
                defaultValue: `Error getting current relationship: ${err?.message || ''}`,
                message: err?.message,
              }),
              err
            )
          })
      } else {
        relationshipState.relationshipData = null
        relationshipActions.updateRelationshipState()
      }
    },
    getRelationshipType: () => {
      if (relationshipState.relationshipData?.associationType) {
        return 'association'
      }
      if (relationshipState.relationshipData?.child) {
        return 'parentchild'
      }
      return 'couple'
    },
    createRelationshipFact: (factConclusion) => {
      postRelationshipFact(relationshipActions.getRelationshipType(), relationshipId, factConclusion)
        .then(() => {
          relationshipActions.fetchCurrentRelationship()
        })
        .catch((err) => {
          error(
            t('queues.errors.creatingRelationshipFact', {
              defaultValue: `Error creating a relationship fact: ${err.message || ''}`,
              message: err.message,
            }),
            err
          )
        })
    },
    updateRelationshipFact: (factConclusion, changeMessage) => {
      putRelationshipFact(relationshipActions.getRelationshipType(), relationshipId, factConclusion, changeMessage)
        .then(() => {
          relationshipActions.fetchCurrentRelationship()
        })
        .catch((err) => {
          error(
            t('queues.errors.editingRelationshipFact', {
              defaultValue: `Error editing relationship fact: ${err.message || ''}`,
              message: err.message,
            }),
            err
          )
        })
    },
    deleteRelationshipFact: (factConclusion, changeMessage) => {
      deleteRelationshipFact(
        relationshipActions.getRelationshipType(),
        relationshipId,
        factConclusion.conclusionId,
        changeMessage
      )
        .then(() => {
          relationshipActions.fetchCurrentRelationship()
        })
        .catch((err) => {
          error(
            t('queues.errors.deletingRelationshipFact', {
              defaultValue: `Error deleting a relationship fact: ${err.message || ''}`,
              message: err.message,
            }),
            err
          )
        })
    },
  }

  return { relationshipState, relationshipActions }
}
